/**
 * Defensive guard against `NUXT_PUBLIC_*` env vars arriving as the literal
 * string "undefined" / "null" at runtime. Amplify (and a few CI providers)
 * have been observed to inject these when a value is unset upstream — and
 * `apiBase: "undefined"` then poisons every URL the app builds:
 *
 *   `${apiBase}/api/public/orders/applyDiscount/...`
 *     → "undefined/api/public/orders/..."
 *     → browser resolves relative → 404 against the site host
 *
 * Runs alphabetically first (prefix `00-`) so all later plugins / stores /
 * composables see a clean value.
 */
const FALLBACKS: Record<string, string> = {
  apiBase: "https://api.anddine.co.uk",
  imageUrl: "https://image.anddine.co.uk",
  mainUrl: "https://anddine.co.uk",
};

function isBlankish(val: unknown): boolean {
  return val === "" || val === "undefined" || val === "null" || val == null;
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const pub = config.public as Record<string, unknown>;

  for (const [key, fallback] of Object.entries(FALLBACKS)) {
    if (isBlankish(pub[key])) {
      pub[key] = fallback;
    }
  }
});
